// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/allSettled
function allSettled(promises) {
  return Promise.all(promises.map(function (promise) {
    return promise.then(function (value) {
      return {
        status: 'fulfilled',
        value: value
      };
    }, function (error) {
      return {
        reason: error,
        status: 'rejected'
      };
    });
  }));
}

/** @return {string} */
function getAddressFirstLine(address) {
  var streetAddress = address.street_address,
      streetAddress2 = address.street_address_2;
  return "".concat(streetAddress || '', " ").concat(streetAddress2 || '').trim();
}

/**
 * https://stackoverflow.com/a/9716488/657193
 *
 * @return {boolean}
 */
function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(Number(n));
}

/** @return {boolean} */

function isEmptyString(value) {
  if (value === null || value === undefined) {
    return true;
  }

  if (isNumeric(value)) {
    return false;
  }

  if (typeof value !== 'string') {
    return true;
  }

  return value.trim() === '';
}

/** @return {string} */

function getAddressSecondLine(address) {
  var city = address.city,
      state = address.state,
      zip = address.zip;
  var useSeparatorComma = !isEmptyString(city) && (!isEmptyString(state) || !isEmptyString(zip));
  var stateAndZip = "".concat(state || '', " ").concat(zip || '').trim();
  return "".concat(city || '').concat(useSeparatorComma ? ',' : '', " ").concat(stateAndZip).trim();
}

/** @return {string} */
function getAddressThirdLine(address) {
  var country = address.country;
  return country || '';
}

/** @return {string} */
function getOrdinalSuffix(number) {
  var onesPlaceValue = number % 10;
  var tensAndOnesPlaceValue = number % 100;

  if (onesPlaceValue === 1 && tensAndOnesPlaceValue !== 11) {
    return 'st';
  }

  if (onesPlaceValue === 2 && tensAndOnesPlaceValue !== 12) {
    return 'nd';
  }

  if (onesPlaceValue === 3 && tensAndOnesPlaceValue !== 13) {
    return 'rd';
  }

  return 'th';
}

/** @return {boolean} */

function isAddressValid(address) {
  var requiredFields = ['street_address', 'city', 'state', 'zip'];
  return requiredFields.every(function (field) {
    return !isEmptyString(address[field]);
  });
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var CordlessUnit = /*#__PURE__*/function () {
  function CordlessUnit(id) {
    _classCallCheck(this, CordlessUnit);

    this.isDefined = false;
    this.isFilled = false;
    this.id = id;
  }

  _createClass(CordlessUnit, [{
    key: "define",
    value: function define() {
      cmWrapper.ads.defineUnit(this.id);
      this.isDefined = true;
    }
  }, {
    key: "setIsFilled",
    value: function setIsFilled(value) {
      this.isFilled = value;
    }
  }]);

  return CordlessUnit;
}();

var CordlessUnitManager = /*#__PURE__*/function () {
  function CordlessUnitManager() {
    var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, CordlessUnitManager);

    this.units = units.map(function (ad) {
      return new CordlessUnit(ad.id);
    });
  }

  _createClass(CordlessUnitManager, [{
    key: "addNewUnitsFoundOnPage",
    value: function addNewUnitsFoundOnPage() {
      var _this = this;

      document.querySelectorAll('.cm-unit').forEach(function (unitElement) {
        if (_this.exists(unitElement.id)) {
          return;
        }

        _this.units.push(new CordlessUnit(unitElement.id));
      });
      return this;
    }
  }, {
    key: "exists",
    value: function exists(id) {
      return this.units.find(function (unit) {
        return unit.id === id;
      }) !== undefined;
    }
  }, {
    key: "getDefinedUnits",
    value: function getDefinedUnits() {
      return this.units.filter(function (unit) {
        return unit.isDefined;
      });
    }
  }, {
    key: "getUnitsOnPage",
    value: function getUnitsOnPage() {
      return this.units.filter(function (unit) {
        return document.getElementById(unit.id) !== null;
      });
    }
  }, {
    key: "getUndefinedUnitsOnPage",
    value: function getUndefinedUnitsOnPage() {
      return this.getUnitsOnPage().filter(function (unit) {
        return !unit.isDefined;
      });
    }
  }, {
    key: "refreshUnfilledDefinedUnitsOnPage",
    value: function refreshUnfilledDefinedUnitsOnPage() {
      var unfilledDefinedUnitsOnPage = this.getUnitsOnPage().filter(function (unit) {
        return unit.isDefined && !unit.isFilled;
      });

      if (unfilledDefinedUnitsOnPage.length > 0) {
        cmWrapper.que.push(function () {
          cmWrapper.ads.refreshUnits(unfilledDefinedUnitsOnPage.map(function (unit) {
            return unit.id;
          }));
          unfilledDefinedUnitsOnPage.forEach(function (unit) {
            return unit.setIsFilled(true);
          });
        });
      }

      return this;
    }
  }, {
    key: "requestUndefinedUnitsOnPage",
    value: function requestUndefinedUnitsOnPage() {
      var undefinedUnitsOnPage = this.getUndefinedUnitsOnPage();

      if (undefinedUnitsOnPage.length > 0) {
        cmWrapper.que.push(function () {
          undefinedUnitsOnPage.forEach(function (unit) {
            return unit.define();
          });
          cmWrapper.ads.requestUnits();
          undefinedUnitsOnPage.forEach(function (unit) {
            return unit.setIsFilled(true);
          });
        });
      }

      return this;
    }
  }, {
    key: "updateListOfFilledUnitsOnPage",
    value: function updateListOfFilledUnitsOnPage() {
      this.getDefinedUnits().filter(function (unit) {
        return unit.isFilled;
      }).filter(function (unit) {
        var _document$getElementB;

        return isEmptyString((_document$getElementB = document.getElementById(unit.id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.innerHTML.trim());
      }).forEach(function (unit) {
        return unit.setIsFilled(false);
      });
      return this;
    }
  }]);

  return CordlessUnitManager;
}();

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var EmbedUrl = /*#__PURE__*/function () {
  function EmbedUrl(url) {
    var _this = this;

    _classCallCheck(this, EmbedUrl);

    this.url = url;
    Object.keys(this.constructor.providers).forEach(function (providerKey) {
      var match = url.match(_this.constructor.providers[providerKey].regex);

      if (match === null) {
        return;
      }

      _this.provider = providerKey;

      if (_this.constructor.providers[providerKey].embedUrl === null) {
        _this.embedUrl = _this.url;
        return;
      }

      if (providerKey === 'brightcove') {
        var _match = _slicedToArray(match, 3),
            accountId = _match[1],
            videoId = _match[2];

        _this.accountId = accountId;
        _this.videoId = videoId;
      } else {
        var _match2 = _slicedToArray(match, 2),
            _videoId = _match2[1];

        _this.videoId = _videoId;
      }

      _this.embedUrl = _this.constructor.providers[providerKey].embedUrl.replace('{accountId}', _this.accountId).replace('{videoId}', _this.videoId);
    });
  }
  /** @return {string} */


  _createClass(EmbedUrl, [{
    key: "getUrl",
    value: function getUrl() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = new URL(this.embedUrl);
      var queryParams = {};

      if (options.autoplay === true) {
        if (this.provider === 'wistia') {
          queryParams.autoPlay = true;
        } else {
          queryParams.autoplay = 1;
        }
      }

      Object.entries(queryParams).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        url.searchParams.set(key, value);
      });
      return url.toString();
    }
    /** @return {boolean} */

  }, {
    key: "hasMatch",
    value: function hasMatch() {
      return this.provider !== undefined;
    }
  }], [{
    key: "providers",
    get:
    /** @return {object} */
    function get() {
      return {
        brightcove: {
          embedUrl: 'https://players.brightcove.net/{accountId}/default_default/index.html?videoId={videoId}',
          label: 'Brightcove',
          regex: /https:\/\/players.brightcove.net\/(\d+)\/default_default\/index.html\?videoId=(\d+)/
        },
        domus: {
          embedUrl: null,
          label: 'Domus',
          regex: /https?:\/\/dashboards.domusanalytics.com\/v\/\w+/
        },
        wistia: {
          embedUrl: 'https://fast.wistia.net/embed/iframe/{videoId}?videoFoam=true',
          label: 'Wistia',
          regex: /https?:\/\/(?:.+)?(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(\w+)/
        },
        vimeo: {
          embedUrl: 'https://player.vimeo.com/video/{videoId}',
          label: 'Vimeo',
          regex: /(?:http|https)?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|)(\d+)(?:|\/\?)/
        },
        youtube: {
          embedUrl: 'https://www.youtube.com/embed/{videoId}',
          label: 'YouTube',
          regex: /(?:https?:\/\/)?(?:youtu\.be\/|(?:www\.|m\.)?youtube\.com\/(?:watch|v|embed)(?:\.php)?(?:\?.*v=|\/))([a-zA-Z0-9\-_]+).*/
        },
        wellcomemat: {
          embedUrl: null,
          label: 'Wellcomemat',
          regex: /https?:\/\/www\.wellcomemat\.com\/embed\/\w+/
        }
      };
    }
  }]);

  return EmbedUrl;
}();

export { CordlessUnitManager, EmbedUrl, allSettled, getAddressFirstLine, getAddressSecondLine, getAddressThirdLine, getOrdinalSuffix, isAddressValid, isEmptyString, isNumeric };
